function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Bills({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.074 1a1 1 0 010 2h-.515v17.135c0 1.654-1.346 3-3 3H5.514c-1.654 0-3-1.346-3-3V3H2a1 1 0 010-2h20.074zm-2.515 2H4.514v17.135c0 .551.45 1 1 1H18.56c.552 0 1-.449 1-1V3zm-4.33 15.005a1 1 0 010 2H8.844a1 1 0 010-2h6.383zM12.254 4.043a1 1 0 011 1v.363c1.34.337 2.517 1.353 2.538 2.965a1.001 1.001 0 01-2 .025c-.01-.777-.87-1.087-1.46-1.113l-.078.006-.117-.007h.117c-.447 0-1.374 0-1.755.363-.228.217-.287.604-.132.862.264.438.952.664 1.636.858l.847.233c.95.284 1.978.7 2.57 1.68.64 1.068.445 2.473-.466 3.342-.497.473-1.115.702-1.7.812v.343a1 1 0 01-2 0v-.279c-1.512-.211-2.952-1.265-2.974-3.05a1 1 0 01.987-1.012c.566.035 1.006.435 1.013.987.01.812.95 1.115 1.54 1.115.112 0 .257 0 .415-.006l.019-.001h.016c.46-.02 1.026-.092 1.303-.356.227-.217.287-.604.132-.863-.24-.397-.845-.622-1.407-.79l-.834-.23c-1.029-.291-2.17-.69-2.81-1.752-.643-1.066-.447-2.471.464-3.34.622-.593 1.434-.802 2.135-.876v-.28a1 1 0 011-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoBills = React.memo(Bills);
export default MemoBills;